import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-029b56d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "box-indicators"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "carousel-inner" }
const _hoisted_4 = ["srcset", "media"]
const _hoisted_5 = ["src"]

import { onMounted, ref, withDefaults, watch } from 'vue';
  import { Carousel } from 'bootstrap';

  export type TImage = {
    imageUrl: string;
    mobileImageUrl?: string;
    link?: string;
  };
  export interface IProps {
    images: TImage[],
    interval?: number | false,
    autoplay?: boolean,
    hiddenDot?: boolean,
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    images: { default: () => [] },
    interval: { type: [Number, Boolean], default: 6000 },
    autoplay: { type: Boolean, default: false },
    hiddenDot: { type: Boolean }
  },
  emits: ['change'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { images: TImage[], interval: number | false, autoplay: boolean, hiddenDot?: boolean }

  
  const root = ref();
  const current = ref(0);
  let carousel: Carousel;

  

  const on = {
    'slide.bs.carousel'(e: Carousel.Event) {
      current.value = e.to;
      emits('change', e);
    }
  };

  const initCarousel = () => {
    if (carousel) {
      carousel.dispose();
    }
    carousel = new Carousel(root.value, {
      interval: props.interval,
    });
    if (props.autoplay) {
      carousel.cycle();
    }
  };

  const handleSlideTo = (to: number) => {
    carousel.to(to);
  };

  function slidePrev() {
    carousel.prev();
  }

  function slideNext() {
    carousel.next();
  }

  watch(
    () => props.images.length,
    initCarousel
  );

  expose({
    handleSlideTo,
    slidePrev,
    slideNext,
    current,
  });

  onMounted(initCarousel);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "root",
    ref: root,
    class: "carousel slide"
  }, _toHandlers(on)), [
    (__props.images.length && !__props.hiddenDot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["indicator", { active: index === current.value }]),
              onClick: ($event: any) => (handleSlideTo(index))
            }, null, 10, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(image.link ? 'a' : 'div'), {
          key: index,
          class: _normalizeClass(["carousel-item", { active: index === 0 }]),
          href: image.link || null
        }, {
          default: _withCtx(() => [
            _createElementVNode("picture", null, [
              (image.mobileImageUrl)
                ? (_openBlock(), _createElementBlock("source", {
                    key: 0,
                    srcset: image.mobileImageUrl,
                    media: `(max-width: ${576}px)`
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                src: image.imageUrl,
                alt: "image"
              }, null, 8, _hoisted_5)
            ])
          ]),
          _: 2
        }, 1032, ["class", "href"]))
      }), 128))
    ])
  ], 16))
}
}

})